import React from "react";

import WrappedPage from "./src/components/WrappedPage";
import WrappedRoot from "./src/components/WrappedRoot";

// custom typefaces
import "@fontsource/tajawal";
import "@openfonts/tajawal_arabic";
import { includes, without } from "ramda";

export const onInitialClientRender = () => {
  window.___MNEMONIC_INITIAL_RENDER_COMPLETE = true;
};

export const wrapPageElement = WrappedPage;
export const wrapRootElement = WrappedRoot;
